module.exports = __webpack_public_path__ + "static/media/Icons-flecha.823cad86.png";